module.exports = __webpack_public_path__ + "files/6e0797a5fcd4b923b602d91cb6f17df7.png";